/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react'
import { fetchProducts } from 'api/products'
import { Product } from 'hooks/useProduct'
import { LoadingContext } from 'contexts/LoadingContext'

export type ProductGroup = {
  [classKey: string]: {
    [colorKey: string]: {
      [itemCategoryKey: string]: {
        [cabinetTypeKey: string]: Product[]
      }
    }
  }
}

const useAllProducts = (
  itemClass: string,
  color?: string,
  itemCategory?: string
) => {
  const [allProducts, setAllProducts] = useState<ProductGroup>({})
  const { showLoading, stopLoading } = useContext(LoadingContext)

  // This request is controlled by the product filter inputs below.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchAllProducts = async () => {
      showLoading()
      const result = await fetchProducts(itemClass, color, itemCategory)

      if (result) {
        const normalizedResult = JSON.parse(
          JSON.stringify(result),
          (key, value) => {
            if (key === 'itemCategory' && typeof value === 'string') {
              return value.split(',').map((cat: string) => cat.trim())
            }
            return value
          }
        )
        setAllProducts(normalizedResult)
      } else {
        setAllProducts({})
      }
      stopLoading()
    }

    fetchAllProducts()
  }, [itemClass, color, itemCategory])

  return {
    allProducts
  }
}

export default useAllProducts
